import React, { useEffect, useState } from "react";
import { fetchTestimonials } from "../lib/api";
import { Star } from "lucide-react";
import { Paisley, BorderOrnament } from "./IndianMotifs";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => { fetchTestimonials().then((d) => setItems(d.items || [])).catch(() => {}); }, []);

  return (
    <section id="voices" aria-label="Patient testimonials" className="relative py-28 md:py-40 bg-cream overflow-hidden">
      <Paisley size={180} className="absolute top-20 -left-6 text-sage-700/10" aria-hidden="true" />
      <Paisley size={160} className="absolute bottom-20 -right-4 text-gold-500/15 rotate-180" aria-hidden="true" />
      <div className="container mx-auto px-5 md:px-10">
        <div className="flex items-end justify-between mb-12">
          <div>
            <div className="text-[11px] uppercase tracking-[0.32em] text-sage-700/80 mb-3">Voices — 04</div>
            <h2 className="font-display text-5xl md:text-6xl xl:text-7xl leading-[1.02] tracking-tightest">
              Heard, <span className="font-script text-gold-500">often</span>.
            </h2>
            <div className="mt-4 text-gold-600/70"><BorderOrnament width={200} /></div>
          </div>
          <div className="hidden md:block text-sm text-ink/60 max-w-xs">
            Real words from clients who walked in curious — and walked out smiling.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="relative rounded-3xl bg-white p-7 border border-sage-700/10 ring-gold-soft tilt-card group"
              style={{ transitionDelay: `${i * 70}ms` }}
            >
              <div className="flex items-center gap-1 text-gold-500" role="img" aria-label={`${t.rating || 5} out of 5 stars`}>
                {Array.from({ length: t.rating || 5 }).map((_, idx) => (
                  <Star key={idx} className="w-3.5 h-3.5 fill-gold-400 stroke-gold-500" aria-hidden="true" />
                ))}
              </div>
              <blockquote className="mt-5 font-display text-[19px] text-ink/85 leading-snug">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6 text-xs uppercase tracking-[0.28em] text-sage-700/70">
                {t.name} <span className="text-sage-700/30 mx-2">/</span> {t.role}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
